import classNames from 'classnames'
import React, { FC } from 'react'
import ChevronSmallIcon from '../../assets/icons/chevron-small.svg'
import ChevronIcon from '../../assets/icons/chevron.svg'

export interface AccordionButtonProps {
  active: boolean
  additionalClassName?: string
  iconColor?: string
  /**
   * If this button-like component is wrapped in another clickable element
   * with desired callback, skip this field
   */
  onClick?: () => void

  /**
   * Render a smaller, compressed variant of this component
   */
  small?: boolean
}

export const AccordionButton: FC<AccordionButtonProps> = ({
  active,
  additionalClassName,
  iconColor = 'text-primary',
  onClick,
  small,
}) => {
  const className = classNames(
    'inline-flex justify-center items-center transition-hover',
    'hover:bg-neutral-lighter-alt group-hover:bg-neutral-lighter-alt',
    'focus:ring group-focus:ring focus:ring-primary/40 group-focus:ring-primary/40 focus:outline-none',
    {
      'w-30 h-30 rounded-5': small,
      'w-45 h-45 rounded': !small,
    },
    additionalClassName
  )

  const iconClassName = classNames(
    'block fill-current transform transition-transform duration-100',
    {
      'w-10 h-10': small,
      'w-15 h-15': !small,

      '-rotate-90': !active && small,
      'rotate-90': active && small,
      'rotate-180': active && !small,
    },
    iconColor
  )

  const content = small ? (
    <ChevronSmallIcon className={iconClassName} />
  ) : (
    <ChevronIcon className={iconClassName} />
  )

  return onClick ? (
    <button className={className} onClick={onClick}>
      {content}
    </button>
  ) : (
    <span className={className}>{content}</span>
  )
}
